import { render, staticRenderFns } from "./UnitsConfiguration.vue?vue&type=template&id=257d8676&scoped=true&"
import script from "./UnitsConfiguration.vue?vue&type=script&lang=js&"
export * from "./UnitsConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./UnitsConfiguration.vue?vue&type=style&index=0&id=257d8676&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257d8676",
  null
  
)

export default component.exports